import React from 'react'
import classNames from 'classnames'
import Loader from 'components/Loader'
import propTypes from 'prop-types'


const Button = ({
  children,
  childrenContainerClassName='',
  className='',
  disabled=false,
  loading=false,
  type='button',
  onClick=() => {},
  theme='default',
}, ref) => {

  return (
    <button
      ref={ref}
      className={classNames([
        'btn',
        theme,
        {'relative': ! className.includes('absolute')},
        className,
        {
          'cursor-wait': loading,
          'cursor-default': disabled,
          'cursor-pointer': !loading && !disabled,
        }
      ])}
      disabled={disabled || loading}
      type={type}
      onClick={onClick}
    >
      <Loader
        active={!!loading}
        className='
          text-white
          absolute left-1/2 top-1/2
          transform -translate-x-1/2 -translate-y-1/2
        '
      />
      <span className={classNames(
        'transition-all',
        childrenContainerClassName,
        {
          'opacity-0': loading,
        }
      )}>
        {children}
      </span>
    </button>
  )
}

Button.propTypes = {
  childrenContainerClassName: propTypes.string,
  type: propTypes.string,
  className: propTypes.string,
  theme: propTypes.oneOf(['default', 'warning', 'danger', 'secondary', 'success', 'disabled']),
  onClick: propTypes.func,
  loading: propTypes.bool,
}

Button.defaultProps = {
  theme: 'default',
  loading: false,
}

export default React.forwardRef(Button)
